import { track, logError } from '@tracking';

import getCart from '@core/reducers/cart/selectors/getCart';
import getCartItemsCount from '@core/reducers/cart/selectors/getCartItemsCount';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import getShop from '@core/reducers/shop/selectors/getShop';
import { getCartStatus } from '@conversion/tracking/utils';

const trackCartClicked = ({ menuSection }) => (_, getState) => {
  const EVENT_NAME = 'cart.clicked';

  try {
    const state = getState();
    const cart = getCart(state);
    const shop = getShop(state);
    const cartQuantity = getCartItemsCount(state);
    const cartStatus = getCartStatus(cart);
    const orderPickup = Boolean(getCartIsPickUp(state));

    const payload = {
      shopId: shop.id,
      cartValue: cart.foodAmount,
      cartQuantity,
      cartStatus,
      menuSection,
      orderPickup,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackCartClicked;
